import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _activateReferralProgramRequest = {};
var _activateReferralProgramResponse = {
    referralProgram: '_referralProgram',
};
var _bulkGetReferralProgramRequest = {};
var _bulkGetReferralProgramResponse = { programInSites: '_programInSite' };
var _coupon = {
    minimumSubtotal: 'DOUBLE',
    fixedAmountOptions: '_fixedAmountDiscount',
    percentageOptions: '_percentageDiscount',
};
var _fixedAmountDiscount = { amount: 'DOUBLE' };
var _generateAISocialMediaPostsSuggestionsRequest = {};
var _generateAISocialMediaPostsSuggestionsResponse = {};
var _getAISocialMediaPostsSuggestionsRequest = {};
var _getAISocialMediaPostsSuggestionsResponse = {};
var _getReferralProgramPremiumFeaturesRequest = {};
var _getReferralProgramPremiumFeaturesResponse = {};
var _getReferralProgramRequest = {};
var _getReferralProgramResponse = { referralProgram: '_referralProgram' };
var _pauseReferralProgramRequest = {};
var _pauseReferralProgramResponse = { referralProgram: '_referralProgram' };
var _percentageDiscount = { percentage: 'DOUBLE' };
var _programInSite = { referralProgram: '_referralProgram' };
var _referralProgram = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    referredFriendReward: '_reward',
    referringCustomerReward: '_reward',
};
var _reward = { couponOptions: '_coupon' };
var _updateReferralProgramRequest = {
    mask: 'google.protobuf.FieldMask',
    referralProgram: '_referralProgram',
};
var _updateReferralProgramResponse = { referralProgram: '_referralProgram' };
function resolveWixLoyaltyReferralProgramV1ReferralProgramsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/referral-programs',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/referral-programs',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/referral-programs',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/referral-programs',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/referral-programs',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/referral-programs',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/referral-programs',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/referral-programs',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/referral-programs',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves the referral program. */
export function getReferralProgram(payload) {
    var _a = serializer(_getReferralProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReferralProgramResponse, {
        _coupon: _coupon,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _percentageDiscount: _percentageDiscount,
        _referralProgram: _referralProgram,
        _reward: _reward,
    }).fromJSON;
    function __getReferralProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.program',
            method: 'GET',
            methodFqn: 'wix.loyalty.referral.program.v1.ReferralPrograms.GetReferralProgram',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixLoyaltyReferralProgramV1ReferralProgramsUrl({
                protoPath: '/v1/program',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReferralProgram.fromReq = fromReq;
    __getReferralProgram.__isAmbassador = true;
    return __getReferralProgram;
}
/**
 * Retrieves multiple referral programs for all metasites that the caller is the member of.
 *
 * Must be called with a [user identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities#identity-types).
 */
export function bulkGetReferralProgram(payload) {
    var _a = serializer(_bulkGetReferralProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetReferralProgramResponse, {
        _coupon: _coupon,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _percentageDiscount: _percentageDiscount,
        _programInSite: _programInSite,
        _referralProgram: _referralProgram,
        _reward: _reward,
    }).fromJSON;
    function __bulkGetReferralProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.program',
            method: 'GET',
            methodFqn: 'wix.loyalty.referral.program.v1.ReferralPrograms.BulkGetReferralProgram',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixLoyaltyReferralProgramV1ReferralProgramsUrl({
                protoPath: '/v1/bulk/programs',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetReferralProgram.fromReq = fromReq;
    __bulkGetReferralProgram.__isAmbassador = true;
    return __bulkGetReferralProgram;
}
/**
 * Updates a referral program. Supports partial updates.
 *
 * Revision number, which increments by 1 each time the referral program is updated.
 * To prevent conflicting changes, the current revision must be passed when updating the referral program.
 */
export function updateReferralProgram(payload) {
    var _a = serializer(_updateReferralProgramRequest, {
        _coupon: _coupon,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _percentageDiscount: _percentageDiscount,
        _referralProgram: _referralProgram,
        _reward: _reward,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateReferralProgramResponse, {
        _coupon: _coupon,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _percentageDiscount: _percentageDiscount,
        _referralProgram: _referralProgram,
        _reward: _reward,
    }).fromJSON;
    function __updateReferralProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.program',
            method: 'PATCH',
            methodFqn: 'wix.loyalty.referral.program.v1.ReferralPrograms.UpdateReferralProgram',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixLoyaltyReferralProgramV1ReferralProgramsUrl({
                protoPath: '/v1/program',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReferralProgram.fromReq = fromReq;
    __updateReferralProgram.__isAmbassador = true;
    return __updateReferralProgram;
}
/** Activates the referral program, changing its status to `ACTIVE`. */
export function activateReferralProgram(payload) {
    var _a = serializer(_activateReferralProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_activateReferralProgramResponse, {
        _coupon: _coupon,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _percentageDiscount: _percentageDiscount,
        _referralProgram: _referralProgram,
        _reward: _reward,
    }).fromJSON;
    function __activateReferralProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.program',
            method: 'PATCH',
            methodFqn: 'wix.loyalty.referral.program.v1.ReferralPrograms.ActivateReferralProgram',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixLoyaltyReferralProgramV1ReferralProgramsUrl({
                protoPath: '/v1/program/activate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __activateReferralProgram.fromReq = fromReq;
    __activateReferralProgram.__isAmbassador = true;
    return __activateReferralProgram;
}
/** Pauses the referral program, changing its status to `PAUSED`. */
export function pauseReferralProgram(payload) {
    var _a = serializer(_pauseReferralProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_pauseReferralProgramResponse, {
        _coupon: _coupon,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _percentageDiscount: _percentageDiscount,
        _referralProgram: _referralProgram,
        _reward: _reward,
    }).fromJSON;
    function __pauseReferralProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.program',
            method: 'PATCH',
            methodFqn: 'wix.loyalty.referral.program.v1.ReferralPrograms.PauseReferralProgram',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixLoyaltyReferralProgramV1ReferralProgramsUrl({
                protoPath: '/v1/program/pause',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __pauseReferralProgram.fromReq = fromReq;
    __pauseReferralProgram.__isAmbassador = true;
    return __pauseReferralProgram;
}
/**
 * Retrieves pre-generated AI social media post suggestions for promoting the referral program.
 *
 * This method returns a list of AI-generated social media post suggestions that site owners or members can use to promote the referral program. You can display these suggestions to allow referring customers to easily copy and share them on their preferred social media platforms.
 *
 * >**Note**: This method retrieves existing suggestions. To generate new ones,
 * use Generate AI Social Media Posts Suggestions.
 */
export function getAiSocialMediaPostsSuggestions(payload) {
    var _a = serializer(_getAISocialMediaPostsSuggestionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAISocialMediaPostsSuggestionsResponse, {}).fromJSON;
    function __getAiSocialMediaPostsSuggestions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.program',
            method: 'GET',
            methodFqn: 'wix.loyalty.referral.program.v1.ReferralPrograms.GetAISocialMediaPostsSuggestions',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixLoyaltyReferralProgramV1ReferralProgramsUrl({
                protoPath: '/v1/program/ai-social-media-posts-suggestions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAiSocialMediaPostsSuggestions.fromReq = fromReq;
    __getAiSocialMediaPostsSuggestions.__isAmbassador = true;
    return __getAiSocialMediaPostsSuggestions;
}
/**
 * Creates new AI-generated social media post suggestions for promoting the referral program.
 *
 * This method generates new AI-powered social media post suggestions for promoting the referral program. Use it to refresh content or create alternatives to existing suggestions.
 *
 * >**Note**: This method generates new suggestions each time it's called. To retrieve existing suggestions without generating new ones, use Get AI Social Media Posts Suggestions.
 */
export function generateAiSocialMediaPostsSuggestions(payload) {
    var _a = serializer(_generateAISocialMediaPostsSuggestionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateAISocialMediaPostsSuggestionsResponse, {}).fromJSON;
    function __generateAiSocialMediaPostsSuggestions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.program',
            method: 'POST',
            methodFqn: 'wix.loyalty.referral.program.v1.ReferralPrograms.GenerateAISocialMediaPostsSuggestions',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixLoyaltyReferralProgramV1ReferralProgramsUrl({
                protoPath: '/v1/program/ai-social-media-posts-suggestions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateAiSocialMediaPostsSuggestions.fromReq = fromReq;
    __generateAiSocialMediaPostsSuggestions.__isAmbassador = true;
    return __generateAiSocialMediaPostsSuggestions;
}
/** Retrieves information about the enabled premium features for the referral program. */
export function getReferralProgramPremiumFeatures(payload) {
    var _a = serializer(_getReferralProgramPremiumFeaturesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReferralProgramPremiumFeaturesResponse, {}).fromJSON;
    function __getReferralProgramPremiumFeatures(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.program',
            method: 'GET',
            methodFqn: 'wix.loyalty.referral.program.v1.ReferralPrograms.GetReferralProgramPremiumFeatures',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixLoyaltyReferralProgramV1ReferralProgramsUrl({
                protoPath: '/v1/program/premium-features',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReferralProgramPremiumFeatures.fromReq = fromReq;
    __getReferralProgramPremiumFeatures.__isAmbassador = true;
    return __getReferralProgramPremiumFeatures;
}
//# sourceMappingURL=http.impl.js.map